// extracted by mini-css-extract-plugin
export default {"base":"base-kABNJ","check":"check-WgdM7"};